import React from 'react';
import {
  Container,
  Typography,
  Box,
  Link,
  Paper,
} from '@mui/material';
import { Instagram } from '@mui/icons-material';
import { motion } from 'framer-motion';

const Contact: React.FC = () => {
  return (
    <Container>
      <Box sx={{ mt: 8, mb: 12 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h2"
            component="h1"
            align="center"
            className="gradient-text"
            sx={{ mb: 4 }}
          >
            İletişim
          </Typography>

          <Paper 
            elevation={3} 
            sx={{ 
              p: 4, 
              mt: 4, 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              background: 'linear-gradient(145deg, rgba(22, 33, 62, 0.9) 0%, rgba(26, 26, 46, 0.9) 100%)',
              backdropFilter: 'blur(10px)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 3,
              }}
            >
              <Typography variant="h5" align="center" gutterBottom>
                Bize Instagram üzerinden ulaşabilirsiniz
              </Typography>

              <Link
                href="https://instagram.com/rosetarot__"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  textDecoration: 'none',
                  color: 'primary.main',
                  '&:hover': {
                    color: 'secondary.main',
                  },
                  transition: 'color 0.3s ease',
                }}
              >
                <Instagram sx={{ fontSize: 40 }} />
                <Typography variant="h6">
                  @rosetarot__
                </Typography>
              </Link>

              <Typography variant="body1" align="center" color="text.secondary" sx={{ mt: 2 }}>
                Tarot seansları ve randevular hakkında detaylı bilgi için
                Instagram hesabımızı takip edebilirsiniz.
              </Typography>
            </Box>
          </Paper>
        </motion.div>
      </Box>
    </Container>
  );
};

export default Contact; 